import { createSlice } from "@reduxjs/toolkit";
import { fetchPharmacyWalletReducer } from "../../reducer/pharmacyWallet/fetchPharmacyWalletReducer";

import i18n from "../../i18n";
const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const pharmacyWalletSlice = createSlice({
  name: "pharmacyWallet",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPharmacyWalletReducer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPharmacyWalletReducer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload || {};
        console.log("✅ Pharmacy Wallet Loaded:", action.payload);
      })
      .addCase(fetchPharmacyWalletReducer.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload || i18n.t("pharmacy.toast.failedToLoadPharmacyWalletDetails");
      });
  },
});

export default pharmacyWalletSlice.reducer;
